import React, { FC } from 'react';
import classNames from 'classnames';
import { Input as ReactStrapInput, InputProps as ReactStrapInputProps, Label } from 'reactstrap';
import { useController, UseControllerProps } from 'react-hook-form';

import PasswordVisibilityToggle from './PasswordVisibilityToggle';

import { usePasswordVisibility } from 'hooks';

type InputProps = ReactStrapInputProps & UseControllerProps<any>;

const Input: FC<InputProps> = ({ control, name, className, id, label, type, ...restProps }) => {
  const {
    field: { ref: fieldRef, ...field },
    fieldState: { invalid, error },
  } = useController({ name, control });
  const { isVisible, inputRef, toggleVisibility } = usePasswordVisibility();
  const isPasswordType = type === 'password';
  const inputType = isPasswordType && isVisible ? 'text' : type;
  const inputId = id || name;

  const assignRef = (node: HTMLInputElement | null) => {
    inputRef.current = node;
    fieldRef(node);
  };

  const inputElement = (
    <ReactStrapInput
      className={classNames('bg-clip-padding', isPasswordType && '!pr-9', className)}
      id={inputId}
      type={inputType}
      innerRef={assignRef}
      {...restProps}
      {...field}
    />
  );

  return (
    <>
      {isPasswordType ? (
        <div className='relative'>
          {inputElement}
          <PasswordVisibilityToggle
            isVisible={isVisible}
            onToggle={toggleVisibility}
            inputId={inputId}
            className='absolute right-3 top-0 h-9'
          />
        </div>
      ) : (
        inputElement
      )}
      {label && (
        <Label for={id} className='mb-0 pl-2 fs--1 text-[#5e6e82]'>
          {label}
        </Label>
      )}
      {invalid && error?.message && (
        <p className='text-[#FD563D] text-xs leading-[14px] pt-1 font-light'>{error?.message}</p>
      )}
    </>
  );
};

export default Input;
